import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconEyeOpened = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#333333",
		d: "M10 3.75C5.835 3.75 2.277 6.342.835 10c1.442 3.658 5 6.25 9.167 6.25 4.166 0 7.725-2.592 9.166-6.25-1.441-3.658-5-6.25-9.166-6.25zm0 10.417c-2.3 0-4.166-1.867-4.166-4.167s1.867-4.167 4.167-4.167S14.167 7.7 14.167 10s-1.866 4.167-4.166 4.167zM10 7.5c-1.383 0-2.5 1.117-2.5 2.5s1.117 2.5 2.5 2.5c1.384 0 2.5-1.117 2.5-2.5S11.385 7.5 10 7.5z"
	})
});
export default SvgIconEyeOpened;
